import { cn } from '@module/lib/utils';
import { IcoLive } from '@module/svg/icons';
import type { HTMLProps } from 'react';

interface Props extends HTMLProps<HTMLDivElement> {}

function LiveBadge({ className, style }: Props) {
  return (
    <div className={cn('absolute z-[5] flex h-[16px] items-center', className)}>
      <IcoLive style={{ fontSize: 32, ...style }} />
    </div>
  );
}

export default LiveBadge;
